/**
 * Which tome vibe an NPC's windows wear (lane N). Config, not code: a zone
 * names its vibe in primitives/tome/zoneTomeVibes.ts (shared with the HUD,
 * plan 17), an NPC takes the vibe of the zone that spawns it
 * (content/zones/*.toml `[[npc_spawns]]`), and a single NPC can override.
 * Vibes themselves live in src/game/ui/primitives/tome/tomeVibes.ts.
 */
import { ZONE_CONFIGS } from '../../../../shared/content/generated/zones.gen';
import type { TomeVibeName } from '../../primitives/tome';
import { zoneTomeVibe } from '../../primitives/tome/zoneTomeVibes';

/** NPC → vibe, for the rare NPC whose window should differ from its zone. */
export const NPC_TOME_VIBES: Partial<Record<string, TomeVibeName>> = {};

let npcZones: Map<string, string> | null = null;

/** The vibe for an NPC's windows: its own override, else its home zone's, else the default. */
export function npcTomeVibe(npcId: string): TomeVibeName {
  const own = NPC_TOME_VIBES[npcId];
  if (own) return own;
  if (!npcZones) {
    npcZones = new Map();
    for (const zone of Object.values(ZONE_CONFIGS)) {
      for (const spawn of zone.npcSpawns) if (!npcZones.has(spawn.npcId)) npcZones.set(spawn.npcId, zone.zoneId);
    }
  }
  const zone = npcZones.get(npcId);
  return zoneTomeVibe(zone);
}
